// Sohbetin ilk mesaji ayari (webchat.openingMessage). Sunucudaki resolveOpeningMessage ile ayni dil sirasi.

function openingConfig(settings) {
    const cfg = ((settings || {}).webchat || {}).openingMessage;
    return cfg && cfg.enabled === true ? cfg : null;
}

// Ozel metin: locale -> site varsayilani -> ilk dolu dil; ayar kapali ya da "ai" ise bos.
function resolveOpeningMessage(settings, locale) {
    const cfg = openingConfig(settings);
    if (!cfg || cfg.source !== "custom") return "";
    const content = (cfg.languageContent || []).filter((x) => x && String(x.text || "").trim());
    const pick = (code) => content.find((x) => x.languageCode === code);
    const siteDefault = settings.language && settings.language.customerClientDefault;
    const entry = pick(locale) || pick(siteDefault) || content[0];
    return entry ? String(entry.text).trim() : "";
}

// "ai" modunda ziyaretcinin ilk mesaji chatbot/AI karsilamasi gelene kadar bekletilir.
function waitsForAiGreeting(settings) {
    const cfg = openingConfig(settings);
    return !!cfg && cfg.source !== "custom";
}

// Karsilama sayilan mesaj: chatbot/AI calisani ya da temsilci; hata ayiklama ve ozel notlar sayilmaz.
function isGreetingMessage(data) {
    const type = String((data && data.messageType) || "");
    if (type === "user") return true;
    return type.indexOf("chatbot") === 0 && type !== "chatbot-debug" && type !== "chatbot-private";
}

module.exports = { resolveOpeningMessage, waitsForAiGreeting, isGreetingMessage };



// WEBPACK FOOTER //
// ./src/utils/openingMessage.js